import React from 'react';
import PropTypes from 'prop-types';
import { Message, translator } from 'mage-i18n';
import { connect } from 'react-redux';
import { ProductPricing } from 'moet-core';
import { getMerchantCountryKey } from '@/selectors/merchant';

import Table from './Table';

const tKey = 'products-fe.components.global_prices_dialog';
const tKeyProducts = 'moet-core.products';

const getCountriesForChildrenPricedProduct = productOptions =>
  productOptions
    .map(option => option.prices.map(price => price.consumerCountry))
    .reduce((acc, optionCountries) => acc.concat(optionCountries), [])
    .reduce((acc, possibleDuplicate) => {
      if (acc.includes(possibleDuplicate)) {
        return acc;
      }
      return acc.concat(possibleDuplicate);
    }, []);

const TableForChildrenPricedProduct = ({ countryCode, productOptions: rawOptions, t }) => {
  const productOptions = rawOptions.filter(o => o.prices);
  const headerCells = [
    <Message key="title" path={`${tKey}.table.country`} />,
    ...productOptions.map(option => {
      return (
        <Message
          key={option.id}
          path={`${tKeyProducts}.${option.name}.${countryCode}`}
          fallback={t(`${tKeyProducts}.${option.name}.default`)}
        />
      );
    }),
  ];

  const rows = getCountriesForChildrenPricedProduct(productOptions).map((countryCode, index) => {
    return [
      <Message key={index} path={`products-fe.countries.${countryCode}`} />,
      ...productOptions.map(option => {
        const price = option.prices.find(price => price.consumerCountry === countryCode);
        return price ? (
          <ProductPricing key={countryCode} price={price} showPerTransactionText={false} />
        ) : (
          '-'
        );
      }),
    ];
  });

  return <Table headerCells={headerCells} rows={rows} striped />;
};

TableForChildrenPricedProduct.propTypes = {
  countryCode: PropTypes.string.isRequired,
  productOptions: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
};

export default connect(state => ({
  countryCode: getMerchantCountryKey(state),
  t: translator(state),
}))(TableForChildrenPricedProduct);
